import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import TNLogo from '../../../Constant/Icons/TamilNadu_Logo.png';
import { serverUrl } from '../../../Constant/Static/config';

const PaymentResult = () => {
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [csrfToken, setCsrfToken] = useState('');
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true  // Ensure cookies are sent
        });
        setCsrfToken(response.data.csrfToken);  // Set CSRF token
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };
    fetchCsrfToken();
  }, []);

  useEffect(() => {
    // localStorage.removeItem('user');
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    // console.log("Calls on the use effect with token :", token);


    if (token) {
      const fetchPaymentDetails = async () => {
        try {
          const response = await axios.get(`${serverUrl}/api/get-payment-details/${token}`, {
            headers: {
              'CSRF-Token': csrfToken  // Use CSRF token
            },
            withCredentials: true
          });
          // console.log("Response from the remote", response.data);

          setTransactionDetails(response.data);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching payment details:', error);
          setErrorMessage(error);
          setLoading(false);
        }
      };

      fetchPaymentDetails();
    }
  }, [csrfToken, location]);

  const handleRedirect = () => {
    // console.log("redirect");
    navigate("/dashboard");
  };

  const handleReceiptGeneration = async (transactionId) => {
    try {
      const response = await axios.post(`${serverUrl}/api/user/doc/generate-receipt`, {
        transactionId
      },
        {
          headers: {
            'CSRF-Token': csrfToken  // Use CSRF token
          },
          withCredentials: true,
          responseType: 'blob',
        });

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Application-PaymentReceipt.pdf`);
        document.body.appendChild(link);
        link.click();
      } else {
        // console.log("Error: ", response);
        // setDefaultForm();
      }

      // const { transactionDetails } = response.data;

      // You can download or display the receipt (either as PDF or HTML)
      // console.log("Receipt details:", transactionDetails);

      // Redirect or show the generated receipt
      // alert("Receipt generated. Check the console or server for details.");
    } catch (error) {
      console.error("Error generating receipt:", error);
      alert("Error generating receipt");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (errorMessage) {
    return (
      <div>
        <h1>Payment Error</h1>
        <p>{errorMessage}</p>
        <button onClick={() => navigate("/dashboard")}>Go Back</button>
      </div>
    );
  }

  return (
    <div className="content-payment">
      <div className="header-payment">
        <div>
          <img alt="TN" src={TNLogo} width={50} height={50} />
        </div>
        <div className="header-content-payment">
          <h3>GOVERNMENT OF TAMILNADU</h3>
          <h4>Tamilnadu Lateral Entry Direct Second Year B.E/B.Tech., Admissions - 2025</h4>
        </div>
        <div> </div>
      </div>
      <div className="payment-body">
        {transactionDetails.Status === "Success" ? (
          <h1 style={{ color: "green" }}>Payment Success</h1>
        ) : (
          <h1 style={{ color: "red" }}> Payment Failed</h1>
        )}
        <div className="payment-content">
          <div className="pay-row">
            <p className="name-pay">Applicant No</p>
            <p className="value-pay">: {transactionDetails.appNo}</p>
          </div>
          <div className="pay-row">
            <p className="name-pay">Amount</p>
            <p className="value-pay">: {transactionDetails.Amount}</p>
          </div>
          <div className="pay-row">
            <p className="name-pay">Transaction ID </p>
            <p className="value-pay">: {transactionDetails.TransactionID}</p>
          </div>
          <div className="pay-row">
            <p className="name-pay">Transaction Type</p>
            <p className="value-pay">: {transactionDetails.TransactionType}</p>
          </div>
          <div className="pay-row">
            <p className="name-pay">Gateway</p>
            <p className="value-pay">: {transactionDetails.Gateway}</p>
          </div>
          <div className="pay-row">
            <p className="name-pay">Bank Reference No</p>
            <p className="value-pay">: {transactionDetails.BankRefNo}</p>
          </div>
          <div className="pay-row">
            <p className="name-pay">Status</p>
            <p className="value-pay">: {transactionDetails.Status}</p>
          </div>
        </div>
        <div className="pay-row">
          <div className="ProceedButton">
            <button
              style={{ margin: "20px" }}
              onClick={() =>
                handleReceiptGeneration(transactionDetails.TransactionID)
              }
            >
              Download Receipt
            </button>
          </div>
          <div className="ProceedButton">
            <button style={{ margin: "20px" }} onClick={() => handleRedirect()}>
              {transactionDetails.Status === "Success" ? 'Proceed To Next' : 'Pay again'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentResult;
